import * as React from 'react';

import { IDisclaimer, IBranding } from '../../../../../../../infrastructure/interfaces';
import { placeholderTypes } from '../../../../../../../infrastructure/placeholderTypes';

export interface IFooterLayoutProps {
  document: any;
  isEditorRendering: boolean;
  disclaimers: Array<IDisclaimer> | null;
}

export interface IFooterLayoutState { }

export default class FooterLayout extends React.Component<IFooterLayoutProps, IFooterLayoutState> {
  constructor(props: IFooterLayoutProps) {
    super(props);
  }


  filterDisclaimers(): Array<IDisclaimer> {
    let disclaimers: Array<IDisclaimer> = [];

    this.props.document.pages.forEach((page: any) => {
      if (page) {
        page.placeholders.forEach((placeholder: any) => {
          if (placeholder.type === placeholderTypes.Product && placeholder.data) {
            disclaimers!.push(...placeholder.data.disclaimers);
          }
        });
      }
    });

    // Remove duplicate disclaimers
    var noDuplicateDisclaimers: Array<any> = [];
    disclaimers.forEach((disclaimer) => {
      var addDisclaimer = true;
      noDuplicateDisclaimers.forEach((noDupeDisclaimer) => {
        if(noDupeDisclaimer.value == disclaimer.value) { addDisclaimer = false; }
      })
      if (addDisclaimer) { noDuplicateDisclaimers.push(disclaimer); }
    })

    return noDuplicateDisclaimers;
  }

  renderFooter() {
    const { document } = this.props;
    const disclaimers = this.filterDisclaimers();
    const filteredBrandings: Array<IBranding> = this.props.document.brandings
      ? this.props.document.brandings.filter((b: any) => b.title !== 'Nutrien Wholesale')
      : [];
    const firstBranding = (filteredBrandings && (filteredBrandings.length > 0)) ? filteredBrandings[0] : undefined;

    if (disclaimers.length == 0) {
      let defaultDisclaimer: IDisclaimer = {
        document_type: "Bulletin",
        value: "defaultDisclaimer",
        description: "© 2020 Loveland Products, Inc. All Rights Reserved. All of the trademarks and service marks displayed are marks of their respective owners. Check State Registration to make sure product is registered in your state.",
      }
      disclaimers.push(defaultDisclaimer)
    }

    return (
      <div className="back-cover-page page-footer">
        {document.companyInfo.isEnabled ?
          <div className={
            document.companyInfo.divisionName ||
              document.companyInfo.phoneNumber ||
              document.companyInfo.email ?
              "division-name" : ''
            }>
            <p className="bulletin-label">Contact</p>
            <span className="bulletin-companyName">{!document.companyInfo.divisionName ?
              '' :
              document.companyInfo.divisionName}</span>
            {document.companyInfo.phoneNumber ?
              <span className="bulletin-phone"><b>P</b> {document.companyInfo.phoneNumber}</span>
              :
              ''}
            {document.companyInfo.email ?
              <span className="bulletin-email"><b>E</b> {document.companyInfo.email}</span>
              :
              ''}
          </div>
        : null }

        <div className="bulletin-footer-content">
          <div className="bulletin-footer-content left">
            <div className="copyright">
              <div className="bulletin-social-container">
                <a href="http://lpi.ag/fbbuilder">
                <div className="bulletin-social-instance">
                    <img className="bulletin-social-image" src={require('../../Images/social_facebook.png')} />
                  </div>
                </a>
                <a href="http://lpi.ag/twitterbuilder">
                  <div className="bulletin-social-instance">
                    <img className="bulletin-social-image" src={require('../../Images/social_twitter.png')} />
                  </div>
                </a>
                <a href="http://lpi.ag/instabuilder">
                  <div className="bulletin-social-instance">
                    <img className="bulletin-social-image" src={require('../../Images/social_instagram.png')} />
                  </div>
                </a>
              </div>
              <div className="always-read-directions">ALWAYS READ AND FOLLOW LABEL DIRECTIONS.</div>
              {
                disclaimers ? disclaimers.map((item, _i) => {
                  return (
                    <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
                  );
                }) :
                null
              }
              <div className="copyrightBottom">LOVELAND PRODUCTS, INC.® &nbsp;&nbsp; | &nbsp;&nbsp;  P.O. BOX 1286 &nbsp;&nbsp;  |  &nbsp;&nbsp; GREELEY, CO 80632  &nbsp;&nbsp; | &nbsp;&nbsp;  www.LovelandProducts.com</div>
            </div>
          </div>
          <div className="brandings-list">
            {
              firstBranding ?  <img key={firstBranding.id} src={firstBranding.coverImage} alt={firstBranding.title} /> : null
            }
          </div>
        </div>
      </div>
    );
  }

  render() {
    return this.renderFooter();
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/Bulletin/Components/FooterLayout/FooterLayout.tsx